import { useCallback, useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useGetUser from "../../../hooks/useGetUser";
import DefRoutes from "../../../routes/routes.json";
import useApi from "../../../services/api";
import { SignOut, UpdateUser } from "../../../store/reducers/auth.reducer";
import { Link } from "react-router-dom";
import t from "../../../i18n/i18n";
import Notify from "../../../components/notification/notify";
import { useHistory } from "react-router";
import "./style.css"

export const ProfileIFrame = () => {
  useGetUser();
  const inputAvatarRef = useRef(null);
  const dispatch = useDispatch();
  const { ApiUpdateUser, ApiGetServers } = useApi();
  const { logged } = useSelector((store) => store.auth);
  const { user } = useSelector((store) => store.auth);
  const { avatar } = user;
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [servers, serServers] = useState([]);
  const [serverSelected, setServerSelected] = useState();

  useEffect(() => {
    ApiGetServers()
      .then((response) => {
        serServers(response.data);
        setServerSelected(0);

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [ApiGetServers]);

  const logout = useCallback(() => {
    window.parent.postMessage({ action: "logout" }, "*");
    dispatch(SignOut());
  }, [dispatch]);

  const changeAvatar = useCallback(
    async (e) => {
      const reader = new FileReader();

      reader.readAsDataURL(e.target.files[0]);

      reader.onload = async (event) => {
        const { data } = await ApiUpdateUser({ avatar: event.target.result });
        dispatch(UpdateUser(data));
      };
    },
    [ApiUpdateUser, dispatch],
  );

  if (!logged) {
    return (window.location = DefRoutes.Embed.SignIn);
  }

  return (
    <div className="profile-main-box embed-main-box-grid vh-100">
      <div className="profile-panel-header embed-profile-panel-header">
        <div className="embed-profile-header">
          <i className="user-icon">
            <img src="/images/user-icon-white.png" alt="" />
          </i>
          <h3>{t("Profile.Title")}</h3>
        </div>
        <div className="embed-profile-logout-container">
          <p onClick={logout}>{t("Menu.Exit")}</p>
        </div>
      </div>
      <div className="profile-inside-warp d-flex flex-column justify-content-center">
        <div className="profile-warp-top">
          <div className="user-profile-thumb">
            <span className="thumb">
              <img
                className="avatar-embed-profile"
                src={avatar || "/images/user-thumn-m.png"}
                alt="Avatar"
                onClick={() => {
                  inputAvatarRef.current.click();
                }}
              />
              <input
                style={{ display: "none" }}
                ref={inputAvatarRef}
                type="file"
                onChange={changeAvatar}
                accept="image/jpeg"
              />
            </span>
          </div>
          <div className="profile-game-nav-large">
            <a href={`${t("Config.MainSite")}/play/?g=${serverSelected}`} target="_parent">
              <span className="nav-icon-title">
                <span className="nav-ico">
                  <img src="/images/game-icon-white2.png" alt="" />
                </span>
                <span className="icon-nav-title text-uppercase">{t("General.Play")}</span>
              </span>
            </a>
          </div>
        </div>
        <div className="server">
          <form className="formulary" action="#">
            <select
              onChange={(event) => setServerSelected(event.target.value)}
              defaultValue=""
              className="select-profile"
              name="option"
            >
              <option value="" disabled>
                {loading ? t("General.LoadingServers") : t("General.SelectServer")}
              </option>
              {servers.map((server) => (
                <option key={server.AreaID} value={server.AreaID}>
                  {server.AreaName}
                </option>
              ))}
            </select>
          </form>
        </div>
        <div className="profile-warp-bot-nav">
          <ul>
            <li>
              <Link to={process.env.REACT_APP_IframeProfile_RechargeCenterLink} target="_parent">
                <span className="nav-icon-title">
                  <span className="nav-ico">
                    <img src="/images/doller-ico-white.png" alt="" />
                  </span>
                </span>
              </Link>
            </li>
            <li>
              <Link to={process.env.REACT_APP_IframeProfile_LoyalMemberLink} target="_parent">
                <span className="nav-icon-title">
                  <span className="nav-ico">
                    <img src="/images/crown-large-white.png" alt="" />
                  </span>
                </span>
              </Link>
            </li>
            <li>
              <Link to={process.env.REACT_APP_IframeProfile_SupportLink} target="_parent">
                <span className="nav-icon-title">
                  <span className="nav-ico">
                    <img src="/images/support-ico-white.png" alt="" />
                  </span>
                </span>
              </Link>
            </li>
            <li>
              <Link to={process.env.REACT_APP_IframeProfile_ConfigLink} target="_parent">
                <span className="nav-icon-title">
                  <span className="nav-ico">
                    <img src="/images/config-icon-white.png" alt="" />
                  </span>
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProfileIFrame;
